/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 21.04.2016
 *
 */
import { ClassRemoteDataStore } from 'plugin/liferay-widgets-react-web';
import FliwasPermissionWebApi from '../webapi/FliwasPermissionWebApi';

import { ActionTypes, ClassNames } from '../constants/Constants';

export default class FliwasPermissionStore extends ClassRemoteDataStore {

    constructor(Dispatcher) {
        super(Dispatcher, ClassNames.FliwasPermission, FliwasPermissionWebApi.listAllNamespaces, FliwasPermissionWebApi.getPermissionStatesByRoleId);
    }

    getSelectedNamespace() {
        return this._state._selectedNamespace || undefined;
    }

    reduce(state, action) {

        if (action.type === ActionTypes.SELECTED_FLIWAS_PERMISSION_NAMESPACE) {
            return {
                ...state,
                _selectedNamespace: action.payload
            };
        }

        return super.reduce(state, action);
    }

}



// WEBPACK FOOTER //
// ./js/stores/FliwasPermissionStore.js